import { getCookies } from "@/util/auth";
import { Message } from "element-ui";
import Vue from "vue";
import Router from "vue-router";
const home = () => import("@/page/home/index"); // 首页

// 问卷总容器
const SurveyLayout = () => import("@/page/survey/layout");

// 问卷编辑模块
const SurveyEditLayout = () => import("@/page/survey/edit/layout.vue");
const SurveyEditBody = () => import("@/page/survey/edit/body");
const SurveyEditAppearance = () => import("@/page/survey/edit/appearance");

// 收集问卷模块
const collectLayout = () => import("@/page/survey/collect/layout");
const collectLink = () => import("@/page/survey/collect/link");
const collectWechat = () => import("@/page/survey/collect/wechat");
const collectVip = () => import("@/page/survey/collect/vip");

//任务分配模块
const taskLayout = () => import("@/page/survey/task/layout");
const taskPerson = () => import("@/page/survey/task/person");
// const taskImport = () => import('@/page/survey/task/import')
const taskAssign = () => import("@/page/survey/task/assign");
const taskNotice = () => import("@/page/survey/task/notice");

// 问卷数据统计模块
const statLayout = () => import("@/page/survey/stat/layout");
const statAnswer = () => import("@/page/survey/stat/answer");
const statAnswerDetail = () => import("@/page/survey/stat/answer-detail");
const statAnalyze = () => import("@/page/survey/stat/analyze");

// 运营端模块
const opLogin = () => import("@/page/op/login");
const opManage = () => import("@/page/op/manage");

// paipai
const paipaiStat = () => import("@/page/paipai/index");
// 街道
const streetLogin = () => import("@/page/street/login");
const streetTaskList = () => import("@/page/street/task-list");
const streetTaskDetails = () => import("@/page/street/task-detail");
const h5 = () => import("@/page/h5/layout");
Vue.use(Router);

let router = new Router({
  mode: "history",
  base: "/admin",
  routes: [
    {
      path: "/",
      name: "home",
      component: home,
    },
    {
      path: "/",
      name: "admin",
      component: () => import("@/page/admin/layout"),
      children: [
        {
          path: "surveys",
          name: "SurveyList",
          component: () => import("@/page/admin/survey/survey-list"),
          meta: {
            keepAlive: true,
            visible: true,
          },
        },
        {
          path: "evaluations",
          name: "EvaluationList",
          component: () => import("@/page/admin/evaluation/project-list"),
          meta: {
            keepAlive: true,
            visible: true,
          },
        },
        {
          path: "paipais",
          name: "PaipaiList",
          component: () => import("@/page/admin/paipai/paipai-list"),
          meta: {
            keepAlive: true,
            visible: true,
          },
        },
        {
          path: "surveyors",
          name: "SurveyorList",
          component: () => import("@/page/admin/surveyor/surveyor-list"),
          meta: {
            keepAlive: true,
            visible: false,
          },
        },
      ],
    },

    // 评估测评
    {
      path: "/evaluations/:id/",
      name: "EvaluationLayout",
      component: () => import("@/page/evaluation/layout"),

      children: [
        {
          path: "form",
          name: "EvaluationFormShow",
          component: () => import("@/page/evaluation/form/show"),
        },
        {
          path: "subjects",
          // name: "EvaluationTasks",
          component: () => import("@/page/evaluation/layout-with-groups-tree"),
          meta: {
            keepAlive: true,
          },
          children: [
            {
              path: "list",
              name: "SubjectList",
              component: () =>
                import("@/page/evaluation/subject/subject-list-main"),
              meta: {
                keepAlive: true,
              },
            },
          ],
        },
        {
          path: "tasks",
          // name: "EvaluationTasks",
          component: () => import("@/page/evaluation/layout-with-groups-tree"),
          meta: {
            keepAlive: true,
          },
          children: [
            {
              path: "list",
              name: "EvaluationTaskEvent",
              component: () => import("@/page/evaluation/task/task-list"),
              meta: {
                keepAlive: true,
              },
            },
            {
              path: ":taskId/detail",
              name: "EvaluationTaskEvents",
              component: () => import("@/page/evaluation/task/task-detail"),
              meta: {
                keepAlive: false,
              },
            },
          ],
        },

        {
          path: "data",
          name: "EvaluationData",
          component: () => import("@/page/evaluation/data/index"),
        },
      ],
    },

    // 问卷调查项目

    {
      path: "/surveys/:id/",
      name: "survey-layout",
      component: SurveyLayout,
      children: [
        {
          path: "",
          name: "survey",
          component: SurveyEditLayout,
          children: [
            {
              path: "edit",
              name: "SurveyEdit",
              component: SurveyEditBody,
            },
            {
              path: "appearance",
              name: "survey-appearance",
              component: SurveyEditAppearance,
            },
          ],
        },

        // 在线问卷收集
        {
          path: "",
          name: "collect",
          component: collectLayout,
          children: [
            {
              path: "link-share",
              name: "SurveyLinkShare",
              component: collectLink,
            },
            {
              path: "wechat-share",
              name: "collect-wechat",
              component: collectWechat,
            },
            {
              path: "order",
              name: "collect-vip",
              component: collectVip,
            },
          ],
        },

        {
          path: "",
          name: "task",
          component: taskLayout,
          children: [
            {
              path: "surveyors",
              name: "SurveySurveyors",
              component: taskPerson,
            },
            // {
            //   path: 'import/:id',
            //   name: 'task-import',
            //   component: taskImport
            // },
            {
              path: "tasks",
              name: "SurveyTasks",
              component: taskAssign,
            },
            {
              path: "notice",
              name: "SurveyNotices",
              component: taskNotice,
            },
          ],
        },
        {
          path: "",
          name: "stat",
          component: statLayout,
          children: [
            {
              path: "answers",
              name: "SurveyAnswers",
              props: true,
              component: statAnswer,
            },
            {
              path: ":aid", //id为问卷id aid为答卷id
              name: "SurveyAnswerDetail",
              props: true,
              component: statAnswerDetail,
            },
            {
              path: "analyze",
              name: "SurveyAnalyze",
              props: true,
              component: statAnalyze,
            },
          ],
        },
      ],
    },
    {
      path: "/street",
      component: () => import("@/page/street/layout.vue"),
      children: [
        {
          path: "login",
          name: "street-login",
          component: streetLogin,
        },
        {
          path: "tasks",
          name: "street-task-list",
          component: streetTaskList,
          meta: {
            keepAlive: true,
          },
        },
        {
          path: "tasks/:id",
          name: "street-task-detail",
          component: streetTaskDetails,
        },
      ],
    },
    {
      path: "/op-login",
      name: "op-login",
      component: opLogin,
    },
    {
      path: "/op-manage",
      name: "op-manage",
      component: opManage,
    },
    {
      path: "/paipai/:id",
      name: "paipaiStat",
      component: paipaiStat,
    },
    {
      path: "/h5",
      name: "h5",
      component: h5,
    },
    {
      path: "*",
      name: "404",
      component: () => import("@/page/404"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  // 不需要验证是否登录的路由
  if (["home", "op-login", "street-login", "h5"].includes(to.name)) {
    next();
    return;
  }
  const token = getCookies("Access-Token");
  const type = getCookies("Token-Type");
  //未登录
  if (!token) {
    Message({
      type: "warning",
      message: "您还没有登录,请先登录",
      center: true,
      duration: 1500,
    });
    next({
      name: "home",
    });
    return;
  }
  //如果是街道角色登录并且去的是街道页面，则通过
  if (type === "street" && to.name.indexOf("street") !== -1) {
    next();
    return;
  }
  //如果是运营角色登录并且去的是运营页面，则通过
  if (type === "op" && /^op-/.test(to.name)) {
    next();
    return;
  }
  //如果是普通用户登录并且去的是非运营页面，则通过
  if (type === "pr" && !/^op-/.test(to.name) && !/^street-/.test(to.name)) {
    next();
    return;
  }
  Message({
    type: "warning",
    message: "您暂无权限执行此操作",
    center: true,
    duration: 1500,
  });
  next({
    name: "home",
  });
});
export default router;
